<template>
  <div class="box">
    <div class="doc_box vux-1px-b">
      <div v-if="lecList && lecList.length == 1" class="one_doc">
        <img
          class="doc_photo"
          :src="
            lecList[0].headPhoto
              ? lecList[0].headPhoto
              : 'https://cdn.yxvzb.com/img/headphoto.png'
          "
          alt=""
        />
        <div class="doc_div">
          <p>
            <span class="name">{{ lecList[0].userName }}</span>
            <span>{{ lecList[0].dutyName }}</span>
          </p>
          <p>
            <span class="doc_company">{{ lecList[0].hospitalName }}</span>
          </p>
        </div>
        <!-- <div class="focus">
          关注
        </div> -->
      </div>
      <ul v-else-if="lecList && lecList.length > 1">
        <li v-for="(item, index) in lecList" :key="index" class="one_doc">
          <img
            class="doc_photo"
            :src="
              item.headPhoto
                ? item.headPhoto
                : 'https://cdn.yxvzb.com/img/headphoto.png'
            "
            alt=""
          />
          <div class="doc_div">
            <p>
              <span class="name">{{ item.userName }}</span>
              <span>{{ item.dutyName }}</span>
            </p>
            <p>
              <span class="doc_company">{{ item.hospitalName }}</span>
            </p>
          </div>
          <!-- <div class="focus">
              关注
            </div> -->
        </li>
      </ul>
    </div>
    <!-- <div class="html_centent" v-show="show" >
      <div class="htmlBodys" v-html="obj.summary" v-if="obj.summary"></div>
      <div class="htmlBodys" v-html="obj.userSummary" v-if="obj.userSummary" style="margin-top: .1rem"></div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },
    lecList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      show: false,
      list: [],
      listIsShow: false
    };
  },
  methods: {
    showMore() {
      this.show = !this.show;
    }
  },
  watch: {
    obj: {
      deep: true,
      handler: function(v) {
        // this.obj = v;
      }
    },
    lecList(v) {
      // this.list = v;
      // if (this.list.length == 1) {
      //   this.listIsShow = true;
      // }
    }
  },
  computed: {},
  components: {},
  created() {},
  mounted() {},
  updated() {
    document.querySelectorAll('.htmlBodys p').forEach(item => {
      item.removeAttribute('style');
    });
    document.querySelectorAll('.htmlBodys span').forEach(item => {
      item.removeAttribute('style');
    });
  }
};
</script>
<style lang="less" scoped>
@import '../../public/style/g.less';

.box {
  margin-top: 0.25rem;
  .focus {
    background-image: linear-gradient(-90deg, #2eacfd 0%, #027cfa 100%);
    border-radius: 0.08rem;
    width: 1.44rem;
    height: 0.59rem;
    text-align: center;
    line-height: 0.59rem;
    color: #fff;
    font-size: 0.32rem;
  }
  .doc_box {
    padding-bottom: 0.2rem;
    width: 100%;
    overflow-y: hidden;
    ul {
      // display: flex;
      // justify-content: flex-start;
      width: 100%;
      li {
        // width: 1.9rem;
        text-align: center;

        img {
          width: 1.07rem;
          height: 1.07rem;
          border-radius: 50%;
        }
        p:nth-of-type(1) {
          margin-top: 0.13rem;
          font-size: 0.37rem;
          color: #191919;
          .textLimit();
        }
        p:nth-of-type(2) {
          font-size: 0.27rem;
          color: #999;
          .textLimit();
        }
      }
    }
  }
  .html_centent {
    margin-top: 0.4rem;

    .borderPadding();
  }
  .htmlBodys {
    font-size: 0.4rem;
    display: flex;
    flex-wrap: wrap;
    * {
      font-size: 0.4rem;
    }
  }
}
.one_doc:last-of-type {
  border-bottom: none;
}
.one_doc {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.4rem 0;
  border-bottom: 1px solid #ebebeb;
  .doc_photo {
    width: 0.906rem;
    height: 0.906rem;
    border-radius: 50%;
    margin-right: 0.266rem;
    display: block;
  }
  .doc_div {
    margin-left: 0.3rem;
    width: 6rem;
    margin-right: 0.2rem;
    text-align: left;
    * {
      font-size: 0.32rem;
    }
    .doc_company {
      width: 7rem;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .name {
      color: #027cfa;
      font-size: 0.3733rem;
      margin-right: 0.066rem;
      font-weight: bold;
    }
  }
}
</style>
